import * as React from 'react';

const NoteIcon = (props) => (
  <svg
    width={24}
    height={28}
    viewBox="0 0 24 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6673 1.02637V6.53376C14.6673 7.28049 14.6673 7.65386 14.8126 7.93907C14.9405 8.18996 15.1444 8.39393 15.3953 8.52176C15.6805 8.66709 16.0539 8.66709 16.8007 8.66709H22.308M14.6673 20.667H6.66732M17.334 15.3337H6.66732M22.6673 11.318V20.9337C22.6673 23.1739 22.6673 24.294 22.2313 25.1496C21.8479 25.9023 21.2359 26.5142 20.4833 26.8977C19.6276 27.3337 18.5075 27.3337 16.2673 27.3337H7.73398C5.49377 27.3337 4.37367 27.3337 3.51802 26.8977C2.76537 26.5142 2.15345 25.9023 1.76996 25.1496C1.33398 24.294 1.33398 23.1739 1.33398 20.9337V7.06699C1.33398 4.82678 1.33398 3.70668 1.76996 2.85103C2.15345 2.09838 2.76537 1.48646 3.51802 1.10297C4.37367 0.666992 5.49377 0.666992 7.73398 0.666992H12.0164C12.9947 0.666992 13.4839 0.666992 13.9442 0.777513C14.3524 0.875499 14.7426 1.03712 15.1005 1.25643C15.5041 1.5038 15.85 1.8497 16.5418 2.54151L20.7928 6.79247C21.4846 7.48428 21.8305 7.83019 22.0779 8.23385C22.2972 8.59174 22.4588 8.98192 22.5568 9.39007C22.6673 9.85042 22.6673 10.3396 22.6673 11.318Z"
      stroke="#334155"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export { NoteIcon };
